var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message"
  }, [_c('v-chip', [('text' in _vm.message && _vm.message.text !== null && _vm.message.text.length) ? _c('message-text', {
    attrs: {
      "message": _vm.message
    }
  }) : _vm._e(), _vm._v(" "), (_vm.message.type === 'human' && _vm.message.audio) ? _c('div', [_c('audio', [_c('source', {
    attrs: {
      "src": _vm.message.audio,
      "type": "audio/wav"
    }
  })]), _vm._v(" "), _c('v-btn', {
    staticClass: "black--text",
    attrs: {
      "left": "",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.playAudio($event)
      }
    }
  }, [_c('v-icon', {
    staticClass: "play-button"
  }, [_vm._v("play_circle_outline")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.message.type === 'bot' && _vm.botDialogState) ? _c('v-icon', {
    class: _vm.botDialogState.color + '--text',
    attrs: {
      "medium": ""
    }
  }, [_vm._v("\n      " + _vm._s(_vm.botDialogState.icon) + "\n    ")]) : _vm._e()], 1), _vm._v(" "), (_vm.shouldDisplayResponseCard) ? _c('div', {
    staticClass: "response-card"
  }, _vm._l((_vm.message.responseCard.genericAttachments), function(card, index) {
    return _c('response-card', {
      key: index,
      attrs: {
        "response-card": card
      }
    })
  })) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-290c8f4f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Message.vue
// module id = 172
// module chunks = 1